const rawConfiguratorValidSizes = ['small', 'medium'] as const;

export type RawConfiguratorSize = (typeof rawConfiguratorValidSizes)[number];

export function isRawConfiguratorSize(size: string): size is RawConfiguratorSize {
  return rawConfiguratorValidSizes.some((x) => x === size);
}
